var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3V21H21V3Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15C18.1569 15 19.5 13.6569 19.5 12C19.5 10.3431 18.1569 9 16.5 9",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9C5.84314 9 4.5 10.3431 4.5 12C4.5 13.6569 5.84314 15 7.5 15",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15V14.8125V13.875V12V9C7.5 6.51472 9.51473 4.5 12 4.5C14.4853 4.5 16.5 6.51472 16.5 9V15C16.5 17.4853 14.4853 19.5 12 19.5",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsm);
export default __webpack_public_path__ + "static/media/csm.46d906e20aba02c22b158274d9f877f4.svg";
export { ForwardRef as ReactComponent };